import { useEffect } from 'react';

type EffectCallback = () => void | (() => void);
export const useAfterFirstRender = (fn: EffectCallback) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(fn, []);
};
